import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import enTranslation from "./en.json"
import frTranslation from "./fr.json"
import itTranslation from "./it.json"
import esTranslation from "./es.json"
import deTranslation from "./de.json"

const resources = {
    en: {
        translation: enTranslation,
    },
    fr: {
        translation: frTranslation,
    },
    it: {
        translation: itTranslation,
    },
    es: {
        translation: esTranslation,
    },
    de: {
        translation: deTranslation,
    },
}

i18n.use(initReactI18next).init({
    resources,
    lng: "fr",
    interpolation: {
        escapeValue: false,
    },
})

export default i18n
